import { render, staticRenderFns } from "./ClientCentricityChecklistEditButton.vue?vue&type=template&id=35f47254"
import script from "./ClientCentricityChecklistEditButton.vue?vue&type=script&lang=js"
export * from "./ClientCentricityChecklistEditButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports